(ns frontend.test.numbers
  (:require [frontend.routing :as routing]
            [reagent.core :as r]
            [basic-components.inputs.footprint :refer [editor viewer]]
            [basic-components.field-editor :as field-editor]))

(defn percentage-view []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h4.title-h3.mt-4.mb-2 "Editor mode"]
       [editor {:editor/type :editor.type/percentage
                :placeholder "percentage"
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [e new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb-3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/percentage
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-percentage-attribute
         :label               "Percentage"
         :hide-label?         false
         :on-save!            (fn [_ v cb! err!]
                                (swap! state assoc :value v)
                                (cb!))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn [])
         :disabled?           false
         :read-only?          false
         :info-text           "Info Integer"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))

(defn currency-view []
  (let [state (r/atom {})]
    [:div.input-editor--input-group
     [:span.input-editor__prepend
      [:i.fas.fa-euro-sign]]
     [editor {:editor/type :editor.type/number
              :state-atom  state
              :value       (:value @state)
              :placeholder "Number"
              :has-focus?  true?
              :on-change!  (fn [new-value]
                             (swap! state assoc :value new-value))}]]))


(defmethod routing/render-view :test/numbers [{:keys [route-params]}]
  (let []
    [:div.container.py-4.bg-white.scroll
     [:h1.title-h1.mb-4 "Numbers"]
     [:h2.title-h2.mt-4 "Percentage"]
     [:span "A percentage field is an input field for entering a number (0 - 100)"]
     [percentage-view]
     [:h2.title-h2.mt-4.mb-2 "Currency"]
     [:label.input-editor__label.mb-2 "A currency field is an input field for entering a number (0 - 9)"]
     [currency-view]]
    ))
